import React from 'react';
import { RouterApp } from './routes/router-app'
import './assets/reset.css'
import './App.css'
import 'keen-slider/keen-slider.min.css'

function App() {
  return (
    <>
      <RouterApp />
    </>
  );
}
export default App;
